import { IStatus } from './../Models/status';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class QuotaService {

  constructor(private http: HttpClient) { }
  public GetQuotas(id: string): Observable<IStatus> {
    let param = new HttpParams();
    param = param.append('id', id);
    return this.http.get<IStatus>('/api/Quota/GetQouta', {params: param});
  }
}
